import React, { useState } from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-white px-5 py-16 sm:px-8" data-id="element-83" data-mp="1lazcje4mzhfh">
      <div className="mx-auto w-full max-w-2xl" data-id="element-84" data-mp="1gcpdutjpdyp4">
        <h2 className="text-center text-3xl font-extrabold tracking-tight text-neutral-900 sm:text-4xl" data-id="element-85" data-mp="1ge0gur5br2f6">
          Frequently Asked <span className="text-ember" data-id="element-86" data-mp="2dzod9c1s5kqp">Questions</span>
        </h2>

        <div className="mt-10 overflow-hidden rounded-xl border border-neutral-200" data-id="element-87" data-mp="292ehzfrpmeuy">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          const panelId = `faq-panel-${index}`;
          return <div key={faq.question} className={index > 0 ? 'border-t border-neutral-200' : ''} data-id="element-88" data-mp="1z5jj2vriycg5" data-mpi={index}>
                <h3 data-id="element-89" data-mp="nnqrfk8jsae0">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={panelId} className="flex w-full items-center justify-between gap-4 bg-neutral-50 px-5 py-5 text-left transition-colors duration-150 ease-out hover:bg-neutral-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-ember" data-id="element-90" data-mp="nmgs6rpykw5s">
                    <span className="text-sm font-extrabold text-neutral-900" data-id="element-91" data-mp="6qf09iq7kxui">
                      {faq.question}
                    </span>
                    {isOpen ? <MinusIcon className="h-4 w-4 shrink-0 text-ember" aria-hidden="true" data-id="element-92" data-mp="3sywmxyjrhyah" /> : <PlusIcon className="h-4 w-4 shrink-0 text-ember" aria-hidden="true" data-id="element-93" data-mp="3jxyn7sgcwcxp" />}
                  </button>
                </h3>
                {isOpen && <div id={panelId} className="bg-white px-5 pb-5 pt-4" data-id="element-94" data-mp="1ui5q1v1zlhh5">
                    <p className="text-sm leading-relaxed text-neutral-600" data-id="element-95" data-mp="1pp33i6vmn8ag">
                      {faq.answer}
                    </p>
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}